import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Text from '../../components/Inputs/Text/Text';
import Toast from '../../components/Toast/Toast';

import {
    isBlank,
    isBlankHelperText,
    isDDDInvalid, 
    isDDDHelperText,
    isPhoneInvalid,
    isPhoneHelperText
} from '../../helper/ValidationHelper';
import { phoneNumberMask, phoneDDDMask } from '../../helper/MaskHelper';

export class TelefoneUnitario extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this)
        this.state = {
            phone: {
                ddd: '',
                number: '',
            },
            errors: {
                ddd: false,
                number: false,
            },
            helpers: {
                ddd: null,
                number: null,
            },
        };
        this.isValid = this.isValid.bind(this);
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            phone: {...this.state.phone, 
                [e.target.name]: 
                    e.target.name === 'number' ? phoneNumberMask(e.target.value) : e.target.name === 'ddd' ? phoneDDDMask(e.target.value) : e.target.value 
            },
            errors: {...this.state.errors, [e.target.name]: false },
            helpers: {...this.state.helpers, [e.target.name]: null }
        })
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    isValid = () => {
        const required = this.props.required;

        const dddBlank = isBlank(this.state.phone.ddd);
        const dddInvalid = isDDDInvalid(this.state.phone.ddd);
        const numberBlank = isBlank(this.state.phone.number);
        const numberInvalid = isPhoneInvalid(this.state.phone.number);

        if ((required && (dddBlank || dddInvalid || numberBlank || numberInvalid))
            || (!required && ((dddBlank !== numberBlank) || (!dddBlank && !numberBlank && (dddInvalid || numberInvalid))))
        ) {
            this.setState({
                errors: {
                    ddd: dddBlank || dddInvalid,
                    number: numberBlank || numberInvalid,
                },
                helpers: {
                    ddd: dddBlank ? isBlankHelperText() : dddInvalid ? isDDDHelperText() : null,
                    number: numberBlank ? isBlankHelperText() : numberInvalid ? isPhoneHelperText() : null,
                },
            })
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                <Toast parentRef={this.setToast} />
                <Grid container spacing={3} direction="row" alignItems='center' justify='flex-start'>
                    <Grid item sm={12} lg={1}>
                        <Typography variant="body2" noWrap>
                            {this.props.name}:
                        </Typography>
                    </Grid>
                    <Grid item sm={4} lg={1}>
                        <Text
                            required={this.props.required}
                            name="ddd"
                            label="DDD"
                            value={this.state.phone.ddd}
                            error={this.state.errors.ddd}
                            onChange={this.handleChange}
                            inputProps={{
                                maxLength: 2,
                            }}
                            helperText={this.state.helpers.ddd}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                    <Grid item sm={8} lg={3}>
                        <Text
                            required={this.props.required}
                            name="number"
                            label="Número"
                            value={this.state.phone.number}
                            error={this.state.errors.number}
                            onChange={this.handleChange}
                            inputProps={{
                                maxLength: 10,
                            }}
                            helperText={this.state.helpers.number}
                            disabled={this.props.disabled}
                        />
                    </Grid>                   
                </Grid>
            </>
        )
    }
}

export default TelefoneUnitario;